import React, {Component} from 'react';
import {Row, Col, Button, Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import Card from "../../comum/components/Card";
import {FecharFiltro, Filtro, IconeCarregar} from "../../comum/components/Icones";
import FiltrosOswebStore from "../stores/FiltrosOswebStore";
import InputFiltro from "../../comum/components/InputFiltro";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import FormOnlyPositiveNumberSimples from '../../comum/components/FormNumberSimples';

@inject("store")
@observer
export default class FIltrosOsweb extends Component {
    constructor(props) {
        super(props);

        this.controllerOsweb = this.props.controller;
        this.controller = new FiltrosOswebStore(this.props.service);

        this.state = { maisFiltros: false, filtrado: false };

    };

    handleFiltrar() {
        this.setState(state => ({filtrado: true}));
        _.set(this.controller.filtros, "status", this.controller.statusSelcionado ? this.controller.statusSelcionado.value : null);
        _.set(this.controller.filtros, "situaOS", this.controller.situacaoSelcionado ? this.controller.situacaoSelcionado.value : null);
        this.controllerOsweb.listar(this.controller.filtros);
    };

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };

    filtrosBasicos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
                <InputFiltro titulo="OS" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        onEnter = { () => this.handleFiltrar() }
                        onChange = { (event) => this.controller.onChangeFiltro("osId", event) } autoFocus={true}/>
                <Col className="col-botoes pl-1" xl={xl} lg={lg} md={md} sm={12} xs={12}>
                    <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                        <Filtro color="#93A0AD" className="mr-2" width="15" height="15"/>
                        Mais filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => this.handleFiltrar() }>Filtrar</Button>
                </Col>
            </React.Fragment>
    };

    filtrosCompletos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
                <InputFiltro titulo="OS" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        onEnter = { () => this.handleFiltrar() }
                        onChange = { (event) => this.controller.onChangeFiltro("osId", event) } />
                <FormSelectSimples titulo="Situação OS" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        itens={ this.controller.situacoesFiltros }
                        dado={ this.controller.situacaoSelcionado }
                        bloqueado={!this.controller.situacoesFiltros}
                        onChange={ (event) => this.controller.onChangeFiltroSituacao(event) } />
                <InputFiltro titulo="Doc / Cntr / NF" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        onEnter = { () => this.handleFiltrar() }
                        onChange = { (event) => this.controller.onChangeFiltro("docCodCntrOuNf", event) } />
                <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
                    <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                        <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
                        Menos filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => this.handleFiltrar() }>Filtrar</Button>
                </Col>
            </React.Fragment>
    };

    mudaFiltros = () => {
        this.setState({maisFiltros: !this.state.maisFiltros});
    };

    render() {
        return(
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        { this.filtros() }
                    </Row>
                </Card>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/osweb/components/FIltrosOsweb.js